export const DISCLAIMER_CONTENT = `I confirm that I have read and understood the Terms and Conditions. I
further understand that by clicking this checkbox, I will be bound by, and
will bind my employer to the Terms and Conditions and my employer will be
responsible for the duties and obligations contained therein`;

export const TERMS_AND_CONDITIONS = "terms_and_conditions";
export const PRIVACY_POLICY = "privacy_policy";
export const CONFIRMATION_CONTENT = `Are you sure you want to reject the license agreement? By clicking 'Proceed',
you acknowledge that you will not be able to use the software.`;

export const LINKS = [
  {
    label: "terms_conditions",
    id: TERMS_AND_CONDITIONS,
    href: `#${TERMS_AND_CONDITIONS}`,
  },
  {
    label: "privacy_policy",
    id: PRIVACY_POLICY,
    href: `#${PRIVACY_POLICY}`,
  },
];
